import { Component, OnInit } from '@angular/core';
import {CoreComponent} from '../../core/core.component';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Results} from '../../core/results';
import {RejectionReasonComponent} from './rejection-reason/rejection-reason.component';
import {RejectionReason} from './rejection-reason/rejection-reason';
import {RejectionReasonsService} from './rejection-reasons.service';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Meta, Title} from '@angular/platform-browser';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
@Component({
  selector: 'app-rejection-reasons',
  templateUrl: './rejection-reasons.component.html',
  styleUrls: ['./rejection-reasons.component.scss']
})
export class RejectionReasonsComponent extends CoreComponent<RejectionReason> {
  @BlockUI() blockUI: NgBlockUI;
  constructor(protected servicesService: RejectionReasonsService, public route: ActivatedRoute,private modalService: NgbModal,
              public activeModal: NgbActiveModal,protected gaService: GoogleAnalyticsService,
              private matSnackBar: MatSnackBar,private router: Router, public meta: Meta, public title: Title) {
    super(servicesService,route);
    this.title.setTitle('Rejection Reasons');
  }

  public search() {
    this.blockUI.start();
    this.servicesService.search(this.currentPage, this.perPage, this.order, this.orderBy, this.keyword)
      .subscribe((data: Results<RejectionReason>) => {
        this.results = data;
        this.blockUI.stop();
      }, (error: HttpErrorResponse) => {
        this.blockUI.stop();
        this.gaService.exception(error.error?.message, true);
        if (error.status === 401) {
          this.activeModal.close();
          this.router.navigate(['/']);
          this.matSnackBar.open('Your session has expired', 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }else {
          this.blockUI.stop();
          this.matSnackBar.open(error.error.message, 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      });
  }

  newItem() {
    this.item = new RejectionReason();
    this.open(this.item);
  }
  open(item: RejectionReason) {
    const modalRef = this.modalService.open(RejectionReasonComponent, {fullscreen:true, modalDialogClass:'animate-bottom'});
    modalRef.componentInstance.item= item;
    modalRef.componentInstance.name = 'World';
    modalRef.closed.subscribe(()=>{
      this.search();
    });
  }

}
